<template>
  <div class="overflow-hidden bg-gray p-2">
    <b-row class="my-2">
      <b-col cols="12">
        <iframe  v-if="localUrl" class="pdf" :src="localUrl+'#toolbar=0'"></iframe>
        <p v-else class="bg-gray min-h-screen text-center">
            <span class="py-5 text-white">Select a document to preview</span>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "BusinessNameAttachments",
  props: {
    url: {
      type: String,
      default: null
    }
  },
  data(){
    return{
      loading:false,
      localUrl: this.url
    }
  },
  watch: {
    url(newVal) {
      this.localUrl = newVal
    }
  },
  methods:{
    openFile(url){
      this.localUrl = url
    }
  },
}
</script>

<style scoped>
.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>